export interface ChartConfig {
  id: string;
  dataKey: string; // Key in TransformedChartData
  title: string;
  description: string;
  adminOnly?: boolean;
  userVisible?: boolean;
}

export const CHART_CONFIGS: ChartConfig[] = [
  {
    id: "monthlyUtilisationCombo",
    dataKey: "monthlyUtilisationCombo",
    title: "Recorded Hours and Utilisation %",
    description: "Monthly view of chargeable hours, non-chargeable hours, and overall utilisation.",
    userVisible: true,
  },
  {
    id: "averageCor",
    dataKey: "averageCor",
    title: "Average Charge-Out Rate (£)",
    description: "Average revenue earned per chargeable hour across all staff.",
    adminOnly: true,
    userVisible: true,
  },
  {
    id: "utilisationByLocation",
    dataKey: "utilisationByLocation",
    title: "Utilisation % by Location",
    description: "Monthly utilisation percentage, one line per office location.",
    userVisible: true,
  },
  {
    id: "nonChargeableHoursByActivity",
    dataKey: "nonChargeableHoursByActivity",
    title: "Non-Chargeable Cost (£) Monthly",
    description: "Total non-chargeable cost in GBP per month across all staff.",
    userVisible: true,
  },
  {
    id: "nonChargeableHoursByActivityBreakdown",
    dataKey: "nonChargeableHoursByActivityBreakdown",
    title: "Non-Chargeable Hours by Activity",
    description: "Non-chargeable hours split across the nine tracked activities.",
    userVisible: true,
  },
  {
    id: "nonChargeableGbpByService",
    dataKey: "nonChargeableGbpByService",
    title: "Non-Chargeable £ by Service Line",
    description: "Non-chargeable cost in GBP split by service line.",
    userVisible: true,
  },
  {
    id: "utilisationByGrade",
    dataKey: "utilisationByGrade",
    title: "Utilisation % by Grade",
    description: "Average utilisation percentage per employee grade.",
    adminOnly: true,
    userVisible: true,
  },
  {
    id: "burnoutRisk",
    dataKey: "burnoutRisk",
    title: "Burnout Risk (%)",
    description: "Share of workforce flagged for sustained overload, based on utilisation, overtime, and time-off patterns relative to grade peers. A heuristic proxy, not a validated burnout measure.",
    userVisible: true,
  },
];

export function getVisibleCharts(isAdmin: boolean): ChartConfig[] {
  return CHART_CONFIGS.filter((chart) =>
    isAdmin ? true : Boolean(chart.userVisible) && !chart.adminOnly
  );
}

